import React, { Component } from 'react'

import { displaySnakeCaseAsTitleCase } from '../../../helpers/displayFormatHelper'
import { UserBannerInfoCard } from './userBannerInfoCard'
import { User } from '../../../core/types'

export interface Props {
  user: User
}

export class UserBannerOtherPanel extends Component<Props> {
  static displayName = 'UserBannerOtherPanel'

  render() {
    const {
      user: { activationState, mlaStatus, client, affiliations },
    } = this.props
    return (
      <div
        className="user-banner__other-panel"
        data-test="user-banner-other-panel"
      >
        <UserBannerInfoCard
          title="Activation state"
          content={activationState}
        />
        <UserBannerInfoCard
          title="Operating system"
          content={client && displaySnakeCaseAsTitleCase(client)}
        />
        <UserBannerInfoCard
          title="MLA status"
          content={mlaStatus && displaySnakeCaseAsTitleCase(mlaStatus)}
        />
        <UserBannerInfoCard
          title="Affiliations"
          content={
            affiliations &&
            affiliations.map((affiliate) => {
              return (
                <div className="user-banner__affiliate" key={affiliate.name}>
                  {affiliate.name}
                </div>
              )
            })
          }
        />
      </div>
    )
  }
}
